import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from 'src/app/common/sharedServices/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard  {
  constructor(private router: Router, private userService: UserService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const actualUserData = await this.userService.getDatiUtente();
    if (actualUserData) {
      this.router.navigateByUrl('/interventi');
      console.debug('Users is logged in and should not access this page');
      return false;
    } else {
      return true;
    }
  }

}
